import React, { useMemo } from "react";
import EpisodesSkeleton from "./EpisodesSkeleton";

const EpisodeSectionSkeleton: React.FC = () => {
  const getSkeletonArray = useMemo(() => {
    return window.innerWidth < 768 ? [1, 2] : [1, 2, 3, 4, 5, 6];
  }, []);
  const getEpisodesSkeletonArray = useMemo(() => {
    if (window.innerWidth < 768) {
      return [1];
    }
    if (window.innerWidth < 1280) {
      return [1, 2];
    }
    return [1, 2, 3];
  }, []);

  return (
    <div>
      <section className="py-10 max-sm:py-4 blue-bg-dots">
        <div className="container !px-4">
          <div className="flex gap-6 mb-7">
            {getSkeletonArray.map((val) => {
              return <div className="skeleton w-[118px] h-10" key={val}></div>;
            })}
          </div>
          <div
            className={`grid ${
              window.innerWidth < 768
                ? "grid-cols-1 mx-auto"
                : window.innerWidth < 1280
                ? "grid-cols-2"
                : "grid-cols-3"
            } gap-8 items-start z-[1] mt-6`}
          >
            {getEpisodesSkeletonArray.map((val) => {
              return <EpisodesSkeleton key={val} />;
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default EpisodeSectionSkeleton;
